import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
export const CHECKOUT_URL = 'https://physics-chemistry.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Get the Physics & Chemistry Ready Pack',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={twMerge('group inline-flex items-center justify-center gap-3 rounded-full bg-cta px-9 py-6 text-center text-sm font-extrabold uppercase leading-tight text-white shadow-cta transition-all duration-200 hover:-translate-y-0.5 hover:bg-cta-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:text-base', className)} data-id="element-43" data-mp="qir19hhk6wt6">
      <span className="-mr-[0.12em] tracking-[0.1em]" data-id="element-44" data-mp="157n32wt0vdlc">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-45" data-mp="35yqpn02be0y8" />
    </a>;
}